
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { handleShowDiscountsModal,handleOfferPriceCalculation} from '../../action';
import { checkName } from '../../redux/reducers/utils';

const DiscountsModal = () => {
    const state = useSelector((state) => state.reducer);
    const dispatch = useDispatch();
    const [showMoreContent, setShowMoreContent] = useState(false)
    const [exclusionsDropdownVisibility, setExclusionDrodownVisibility] = useState(false)

    let arr = [] 

    state?.discount_Offers?.length > 0 && state?.discount_Offers[0]?.offers.map((of) => {
        arr = [...arr ,...of.states]
    })

    const scrollToOption = () => {
        setShowMoreContent(true)
        setExclusionDrodownVisibility(false)
        setTimeout(() => {
            let ele = document.getElementById('detail-description')
            ele.scrollIntoView(0,0)            
        }, 10);
    };

    const showDescrption=(data)=>{
        let charCount = data.length
        charCount = parseInt(charCount) > 135 ? true : false
        
        return <div id="detail-description" className={`detail-description ${!showMoreContent ? 'show-ellipsis' : ''}`}>
            {charCount && !showMoreContent ? `${data.slice(0, 135 - 3)}...` : data}           
            {charCount && !showMoreContent &&
                <span className='read-more-content' onClick={()=>scrollToOption()}>read more</span> 
            }
        </div>
    }

    // ############################ The function checks whether all the exclusions exist in the selected manufacturer and returns an array of exclusions that exist ###########################
    let checkOffer = true;
    if(state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount']!=undefined && state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n]!=undefined)
    {
      if(state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n]!=undefined && state.const_var.stateManufacturerAcordingAPIDiscount['mfg_discount'][state.params.m_s_n].length==0)
      {
        checkOffer = false;
      }
    }

    const exclusionsArr = state.const_var.discount_info?.exclusions_for_crm?.arr ?? [] 

    return (
        <div className={`${state.isShowDiscountsModal ? 'show-discounts' : ''}`}>
            <div className={`discount-modal-overlay`}></div>
            <div className={`discounts-modal-container`}>
                <div className={`discounts-modal-content ${exclusionsArr.length ? 'pb-0' : '' }`}>
                    <div className='discount-top-wrap'>
                        <div className='discounts-modal-title'>
                            {state?.discount_Offers?.length > 0 && state?.discount_Offers[0]?.name}
                        </div>
                        <div className={state?.higherOfferPercentage > 0 && checkOffer ? 'discounts-modal-comment' : 'd-none'}>
                            <div className='discounts-comment-title'>UP TO</div>
                            <div className='discounts-comment-value'>{state?.higherOfferPercentage && parseFloat(state?.higherOfferPercentage)}% OFF</div>
                        </div>
                    </div>

                    <div className='discounts-offers-container'>
                        {
                             state?.discount_Offers?.length > 0 && state.discount_Offers[0]?.offers?.map((item, index, array) => 
                                <div key={index} className='offers-item'>
                                    <div className='offers-header'>
                                        <div className='offer-title'>
                                            Offer {array.length === 1 ? "" : index+1} :
                                        </div>
                                        <div className='offer-per'>
                                            {item.amount && parseFloat(item.amount)}%
                                        </div>
                                    </div>
                                    <div className='offers-content'>
                                        <div className='offers-content-item'>
                                            <div className='item-title'>Price Range</div>
                                            <div className='item-split'> : </div>
                                            <div className='item-value'>
                                                {
                                                    item.price_to != undefined && item.price_to > 0
                                                    ?
                                                        `$${item?.price_from ? parseFloat(item.price_from).toFixed(2): "0.00"} - $${item?.price_to ? parseFloat(item.price_to).toFixed(2) : "0.00" }`
                                                    :
                                                        "All"
                                                }
                                            </div>
                                        </div>
                                        <div className='offers-content-item'>
                                            <div className='item-title'>Width Range</div>
                                            <div className='item-split'> : </div>
                                            <div className='item-value'>
                                                {
                                                    item.width_to != undefined && item.width_to > 0
                                                    ?
                                                        <>
                                                            {item.width_from+"'"} - {item.width_to+"'"}
                                                        </>    
                                                    :
                                                    "All"
                                                }
                                                </div>
                                        </div>
                                        
                                        <div className='offers-content-item'>
                                            <div className='item-title'>States</div>
                                            <div className='item-split'> : </div>
                                            <div className='item-value'>{item?.state_names != undefined ? item.state_names : "All"}</div>
                                        </div>
                                        <div className='offers-content-item'>
                                            <div className='item-title'>Building Type</div>
                                            <div className='item-split'> : </div>
                                            <div className='item-value'>{item?.building_names != undefined ? checkName(item.building_names) : "All" }</div>
                                        </div>
                                        {
                                            state.const_var.loginSession && (
                                                <div className='offers-content-item'>
                                                    <div className='item-title'>Applied On</div>
                                                    <div className='item-split'> : </div>
                                                    <div className='item-value uppercase'>{item.applied_on ? item.applied_on.replace("_"," ") : "-"}</div>
                                                </div>
                                            )
                                        }
                                        
                                    </div>
                                </div>
                            )
                        }
                        {
                            state?.discount_Offers?.[0]?.description != '' && state?.discount_Offers?.[0]?.description != undefined && (
                                <div className='discount-detail-wrap'>
                                    <div className='detail-heading-sec'>
                                        <span className='detail-heading'>Discount Details : </span>
                                        <span className='detail-heading-line'></span>
                                    </div>
                                    {showDescrption(state.discount_Offers[0].description)}
                                </div>
                            )
                        }
                    </div>

                    {   
                        exclusionsArr.length > 0 && (
                            <div className={'discount-exclusion' + (exclusionsDropdownVisibility ? ' show' : '')}>
                                <div className='head' onClick={()=> setExclusionDrodownVisibility(!exclusionsDropdownVisibility)}>Discount Exclusions <i className={exclusionsDropdownVisibility ? 'icon-cross-ico' :  'icon-arrow-down-ico'}></i></div>
                                {
                                    exclusionsDropdownVisibility && (
                                        <div className='exclusions'>
                                            {
                                                exclusionsArr.map((item,index, arr)=>{
                                                    return <>{item} {index != (arr.length - 1) && `, `}</>
                                                })
                                            }
                                        </div>
                                    )

                                }
                            </div>
                        )
                    }
                </div>
                <div className='discounts-modal-footer'>
                    <div className='footer-title'>
                        <div className='title-opa'>
                            Offer <br/><span className='ends-in'>Ends in</span> &nbsp; 
                        </div>
                        <div> :  &nbsp;</div>
                    </div>
                    <div className='discounts-time' id="discountTimer">
                    </div>
                    <div className={arr.length > 0 ? (arr.includes(state.params.p_s_n) ? 'applied-space' : 'd-none') : 'applied-space'} >
                        {
                            (state.const_var.post_data.building != undefined && state.const_var.post_data.building.discount_amount!=0 && state.const_var.offerId != undefined && state.const_var.offerId != '' && state.const_var.showAppliedButton)
                            ?
                                <>
                                    <div className='offer-value'>Applied <span class="icon-checkmark-ico"></span></div>
                                </>
                            :(state.const_var.offerId != undefined && state.const_var.offerId != "" && state.const_var.showActiveButton)
                                ?
                                    <>
                                        <div className="offer-value cursor-pointer" onClick={() => dispatch(handleOfferPriceCalculation(state.const_var.offerId))}>Apply</div>
                                    </>
                                :
                                    null
                        }
                    </div>
                </div>
                <div className='discounts-modal-close' onClick={() => {
                    setShowMoreContent(false);
                    dispatch(handleShowDiscountsModal())
                }}>
                    <i className='icon-close'></i>
                </div>
            </div>
        </div>
    )
}

export default DiscountsModal